import React from 'react';
import classNames from 'classnames';
import { Input as AntdInput } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { InputProps as AntdInputProps } from 'antd/lib/input';
import { useThemeVarsClass } from '../../../theme/provider';
import cn from './styles.module.scss';

export interface InputProps extends AntdInputProps {
  label?: string,
  error?: string,
}

export const Input = React.forwardRef(({
  className,
  size = 'large',
  error,
  prefix,
  suffix,
  onChange,
  value,
  label,
  name,
  ...props
}: InputProps, ref) => {
  const themeClassName = useThemeVarsClass();

  return (
    <div className={classNames(cn.inputContainer, themeClassName, className)}>
      {label && (
        <label htmlFor={name} className={cn.label}>{label}</label>
      )}
      <AntdInput
        className={classNames(
          cn.input,
          {
            [cn.error]: Boolean(error),
            [cn.prefix]: Boolean(prefix),
            [cn.suffix]: Boolean(suffix),
          }
        )}
        prefix={prefix}
        name={name}
        suffix={suffix}
        ref={ref as any}
        onChange={onChange}
        value={value}
        size={size}
        {...props}
      />
      {!!error && (
        <div className={cn.errorContainer}>
          <ExclamationCircleFilled className={cn.icon} />
          {error}
        </div>
      )}
    </div>
  )
});

Input.displayName = 'Input';
